// src/components/BackSearchGo.js
import React from "react";
import GlobeSearch from "./GlobeSearch";
import { useNavigate, useParams } from "react-router-dom";

export default function BackSearchGo({ onHighlight, onBack, onNewSearch }) {
  const navigate = useNavigate();
  const { region } = useParams(); // Detect which map we are on

  const handleBack = () => {
    if (onBack) {
      onBack();
      return;
    }

    const current = region?.toLowerCase();

    // ⭐ Puerto Rico map → USA map
    if (current === "puertorico") {
      navigate("/map/usa", { replace: true });
      return;
    }

    // ⭐ USA map → TravelInsights
    if (current === "usa") {
      navigate("/travel", { replace: true });
      return;
    }

    // ⭐ World map → USA map
    if (current === "world") {
      navigate("/map/usa", { replace: true });
      return;
    }

    // ⭐ Oregon map → USA map  (ADDED)
    if (current === "oregon") {
      navigate("/map/usa", { replace: true });
      return;
    }
    // ⭐ Colorado map → USA map
if (current === "colorado") {
  navigate("/map/usa", { replace: true });
  return;
}


    // ⭐ Fallback for non-map pages
    navigate(-1);
  };

  return (
    <div className="search-group">
      <GlobeSearch
        onNavigate={(path) => navigate(path)}

        // Reset highlight when user types a new search
        onNewSearch={() => {
          if (onNewSearch) onNewSearch();
        }}

        // Forward only the ID
        onHighlight={(id) => {
          if (onHighlight) onHighlight(id);
        }}
      />

      <button
        className="main-button go-back-inline"
        onClick={handleBack}
      >
        Go Back
      </button>
    </div>
  );
}
